export default {"src":"/_next/static/media/PROJECT_DETAILS_ACTIVE_ICON.2f4fba82.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};